var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#4B4AD5",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4457 8.62096L12.0923 16.6826L9.87568 14.3143C9.46734 13.9293 8.82568 13.906 8.35901 14.2326C7.90401 14.571 7.77568 15.166 8.05568 15.6443L10.6807 19.9143C10.9373 20.311 11.3807 20.556 11.8823 20.556C12.3607 20.556 12.8157 20.311 13.0723 19.9143C13.4923 19.366 21.5073 9.81096 21.5073 9.81096C22.5573 8.73762 21.2857 7.79262 20.4457 8.60929V8.62096Z",
    fill: "#4B4AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.5473dae3d7104d2b999c9f3bd2d99f64.svg";
export { ForwardRef as ReactComponent };